var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuThemeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.125,
    height: 21.375,
    viewBox: "0 0 26.125 21.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bulk_Scan",
    "data-name": "Iconly/Bulk/Scan",
    transform: "translate(-1.188 -3.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scan",
    transform: "translate(1.188 3.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M5.243,8.934a.332.332,0,0,1-.321-.32V7.135a2.694,2.694,0,0,1,2.7-2.69h6.559a2.684,2.684,0,0,1,2.7,2.69V8.614a.333.333,0,0,1-.325.32Zm14.743-2.09v-2.2a2.9,2.9,0,0,0-2.922-2.865H15.173a.9.9,0,0,1-.9-.885.9.9,0,0,1,.9-.888h1.892a4.688,4.688,0,0,1,4.729,4.638v2.2a.9.9,0,0,1-1.807,0ZM0,6.842V4.634A4.685,4.685,0,0,1,4.72,0H6.655a.9.9,0,0,1,.9.887.894.894,0,0,1-.9.886H4.721a2.893,2.893,0,0,0-2.912,2.86V6.842a.9.9,0,0,1-.9.887A.9.9,0,0,1,0,6.842Z",
    transform: "translate(2.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M25.221,0H.9A.9.9,0,0,0,0,.887a.9.9,0,0,0,.9.885h1.26V6a4.686,4.686,0,0,0,4.72,4.633H8.82a.887.887,0,1,0,0-1.773H6.888A2.893,2.893,0,0,1,3.973,6V1.772H7.088V2.95A2.694,2.694,0,0,0,9.783,5.641h6.56a2.694,2.694,0,0,0,2.7-2.691V1.772h3.115V6A2.9,2.9,0,0,1,19.23,8.865H17.339a.887.887,0,1,0,0,1.773H19.23A4.69,4.69,0,0,0,23.96,6V1.772h1.261a.9.9,0,0,0,.9-.885.9.9,0,0,0-.9-.887",
    transform: "translate(0 10.736)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuThemeIcon);
export default __webpack_public_path__ + "static/media/menu_themeIcon.fcaafd64b261472434be760d9e68f300.svg";
export { ForwardRef as ReactComponent };